import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { FormGroup, Input, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import { Colxx } from '../../../components/common/CustomBootstrap';
import { CommonFormRadioGroup } from '../../../components/common/CustomFormComponents';
import CloseIcon from '@material-ui/icons/Close';

export const RentalReturnStep2 = ({
  visible,
  toggle,
  handleClose,
  selectedProduct,
  onNextClick,
}) => {
  const data = [
    {
      id: 1,
      title: 'I loved it but am ready to switch it up!',
      isSelected: true,
      options: [
        {
          title: 'How many times did you wear this item?',
          options: [
            {
              label: '0 times',
              value: '0 times',
            },
            {
              label: '1 time',
              value: '1 time',
            },
            {
              label: '2 times',
              value: '2 times',
            },
            {
              label: '3 times',
              value: '3 times',
            },
            {
              label: '4+ times',
              value: '4+ times',
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: 'This is fit return',
      options: [
        {
          title: 'What was wrong with the fit?',
          options: [
            {
              label: 'Too big',
              value: 'Too big',
            },
            {
              label: 'Too small',
              value: 'Too small',
            },
            {
              label: 'Too long',
              value: 'Too long',
            },
            {
              label: 'Too short',
              value: 'Too short',
            },
          ],
        },
        {
          id: 3,
          title: 'How many times did you wear this item?',
          options: [
            {
              label: '0 times',
              value: '0 times',
            },
            {
              label: '1 time',
              value: '1 time',
            },
            {
              label: '2 times',
              value: '2 times',
            },
            {
              label: '3 times',
              value: '3 times',
            },
            {
              label: '4+ times',
              value: '4+ times',
            },
          ],
        },
      ],
    },
    {
      id: 4,
      title: 'There was a problem with this item',
      options: [
        {
          title: 'Please select the problem with this item.',
          options: [
            {
              label: 'Poor quality',
              value: 'Poor quality',
            },
            {
              label: 'Item was not what i expected',
              value: 'Item was not what i expected',
            },
            {
              label: 'Item was damaged when i received it',
              value: 'Item was damaged when i received it',
            },
            {
              label: 'Wrong item received',
              value: 'Wrong item received',
            },
            {
              label: 'Item did not match website description',
              value: 'Item did not match website description',
            },
            {
              label: 'Other',
              value: 'Other',
            },
          ],
        },
        {
          title: 'How many times did you wear this item?',
          options: [
            {
              label: '0 times',
              value: '0 times',
            },
            {
              label: '1 time',
              value: '1 time',
            },
            {
              label: '2 times',
              value: '2 times',
            },
            {
              label: '3 times',
              value: '3 times',
            },
            {
              label: '4+ times',
              value: '4+ times',
            },
          ],
        },
      ],
    },
    // {
    //   id: 5,
    //   title: 'Other',
    //   options: [
    //     {
    //       title: 'Please describe your reason for return.',
    //       description: true,
    //     },
    //     {
    //       title: 'How many times did you wear this item?',
    //       options: [
    //         {
    //           label: '0 times',
    //           value: '0 times',
    //         },
    //         {
    //           label: '1 time',
    //           value: '1 time',
    //         },
    //         {
    //           label: '2 times',
    //           value: '2 times',
    //         },
    //         {
    //           label: '3 times',
    //           value: '3 times',
    //         },
    //         {
    //           label: '4+ times',
    //           value: '4+ times',
    //         },
    //       ],
    //     },
    //   ],
    // },
  ];

  const [optData, setOptData] = useState([]);
  const [selectedOpt, setSelectedOpt] = useState(null);

  useEffect(() => {
    setOptData(data);
    setSelectedOpt(data.find((d) => d.isSelected));
  }, []);

  const renderButton = () => {
    return (
      <div
        style={{
          position: 'absolute',
          bottom: '5%',
          display: 'flex',
          justifyContent: 'flex-end',
          right: '15%',
          left: 0,
        }}
      >
        <ButtonWithLoadingIcon
          style={{
            alignSelf: 'center',
            width: '30%',
            marginBottom: 10,
          }}
          type='submit'
          color={'primary'}
          onClick={() => {
            // setShowStep2(true);
            if (onNextClick) {
              onNextClick(selectedOpt);
            }
          }}
          textClassName={'btn-next-style'}
        >
          Next
        </ButtonWithLoadingIcon>
      </div>
    );
  };

  return (
    <Modal
      isOpen={visible}
      toggle={toggle}
      backdrop='static'
      wrapClassName='modal-center'
      style={{ maxWidth: '65%', border: `1px solid #2E2B2B` }}
      // className={`${className} details-modal`}
    >
      <ModalHeader className='detail-modal-header'>
        <div
          className='d-flex align-items-center'
          style={{ justifyContent: 'space-between' }}
          onClick={handleClose}
        >
          <span
            className='btn-name'
            style={{ color: '#2E2B2B', fontFamily: 'Brown', fontSize: 22 }}
          >
            Please select the reason for return (2 of 2)
          </span>
          <CloseIcon />
        </div>
      </ModalHeader>
      <ModalBody className='content' style={{ padding: 0 }}>
        <div className='d-flex'>
          <div
            style={{
              width: '45%',
              backgroundColor: '#F5E5D9',
              padding: 25,
              paddingBottom: '22%',
            }}
          >
            <div
              className='d-flex product-view'
              style={{ backgroundColor: '#F5E5D9' }}
            >
              {selectedProduct?.img_url ? (
                <div
                  className={'mr-3'}
                  style={{ height: 170, width: 200, borderRadius: 8 }}
                >
                  <img
                    src={selectedProduct.img_url}
                    alt={selectedProduct.title}
                    style={{ height: '100%', width: '100%', borderRadius: 8 }}
                  />
                </div>
              ) : null}
              <div style={{ marginTop: 8, width: '100%' }}>
                <span style={{ fontFamily: 'Brown', fontSize: 20 }}>
                  {selectedProduct.brand.toUpperCase() || '--'}
                </span>
                <br />
                <span
                  className='mb-2'
                  style={{ fontFamily: 'Brown', fontSize: 20 }}
                >
                  {selectedProduct.title || selectedProduct.product_title || ''}
                </span>
                <br />
                <span>{`${selectedProduct.size
                  .toString()
                  .toUpperCase()}/${selectedProduct.color.toUpperCase()}`}</span>
              </div>
            </div>
            {optData.map((opt, index) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: 10,
                    borderRadius: 6,
                    border: opt.isSelected
                      ? `2px solid #2E2B2B`
                      : `1px solid #8f837d`,
                    marginTop: index === 0 ? 35 : 5,
                    marginBottom: 20,
                  }}
                  onClick={() => {
                    setOptData(
                      optData.map((option, ind) => {
                        if (option.id === opt.id) {
                          return {
                            ...opt,
                            isSelected: true,
                          };
                        } else {
                          return {
                            ...option,
                            isSelected: false,
                          };
                        }
                      })
                    );
                    setSelectedOpt(
                      optData.find((option) => option.id === opt.id)
                    );
                  }}
                >
                  <span>{opt.title}</span>
                  <div
                    className={`glyph-icon simple-icon-arrow-right`}
                    style={
                      opt.isSelected
                        ? { fontWeight: 'bold', color: '#2E2B2B' }
                        : {}
                    }
                  />
                </div>
              );
            })}
          </div>
          <div style={{ width: '55%', padding: 25, paddingBottom: '3%' }}>
            {selectedOpt?.options.map((o) => {
              return (
                <div>
                  <Colxx sm={12} className='transfer-options mb-4'>
                    <span style={{ fontSize: 14, fontFamily: 'Brown Bold' }}>
                      {o.title}
                    </span>
                    {o.options ? (
                      <CommonFormRadioGroup
                        name='return_option'
                        value={
                          o.options.find((opt) => opt.isSelected)?.value || ''
                        }
                        id='return-option'
                        onChange={(name, value) => {
                          setSelectedOpt({
                            ...selectedOpt,
                            options: selectedOpt.options.map((opt) => {
                              if (opt.title === o.title) {
                                return {
                                  ...opt,
                                  options: opt.options.map((op) => {
                                    if (op.value === value) {
                                      return {
                                        ...op,
                                        isSelected: true,
                                      };
                                    } else {
                                      return {
                                        ...op,
                                        isSelected: false,
                                      };
                                    }
                                  }),
                                };
                              } else {
                                return {
                                  ...opt,
                                };
                              }
                            }),
                          });
                        }}
                        onBlur={(name, value) => {
                        }}
                        notInline={true}
                        options={o.options}
                      />
                    ) : o.description ? (
                      <Input
                        id='description'
                        name='description'
                        type='textarea'
                        style={{ borderRadius: 15, height: 180 }}
                      />
                    ) : null}
                  </Colxx>
                </div>
              );
            })}
            {renderButton()}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
